import { CommonState, Fetcher } from '@primeit/components-vue';
import { Config } from '@dav/security-component-spa';

const module = {
  actions: {
    FETCH_COMPANY_FINANCERESUME: async (context, params) => {
      let json;
      try {
        const response = await Fetcher(
          `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/${params.companyId}/financialresume`
        );
        if (response.ok) {
          json = await response.json();
        }
      } catch (e) {
        json = {
          code: 400,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('POPULATE_COMPANY_FINANCERESUME', json);
    },
    FETCH_ONE: async (context, params) => {
      let response;
      let json;

      try {
        response = await Fetcher(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/${params.companyId}/settings`);
        if (response.ok) {
          json = await response.json();
        }
      } catch (e) {
        json = {
          code: 400,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }
      context.commit('POPULATE_ONE', json);
    },
    FETCH_COST_CENTER_SETTINGS: async (context, params) => {
      const costCenterId = sessionStorage.getItem('costCenterId');
      let response,
        json = {
          cost_center_id: 'DEFAULT_CONFIG',
          name: 'Default Config',
          provider: {
            measurements: {
              attendance: null,
              flow: 'VT_M',
            },
          },
          status: true,
        };

      if (costCenterId) {
        try {
          const config = await Config.getInstance();
          const company_id = config.get('dav-company-id');

          response = await Fetcher(
            `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/${company_id}/costCenter/${costCenterId}`
          );
          if (response.ok) {
            json = await response.json();
          }
        } catch (e) {
          ///
        }
      }

      context.commit('POPULATE_COST_CENTER_SETTINGS', json);
    },
  },
  getters: {
    GET_FINANCERESUME: (state) => {
      return JSON.parse(JSON.stringify(state.financeresume));
    },
    GET_ONE: (state) => {
      return JSON.parse(JSON.stringify(state.entity));
    },

    /**
     * Representa a configuração de um centro de custo, especialmente para um totem de atendimento.
     * @typedef {object} CostCenterConfig
     * @property {string} cost_center_id - O identificador único do centro de custo. Pode ter valores especiais como "TOTEM_NULL" para indicar um totem que não está associado a um centro de custo específico.
     * @property {string} name - Um nome descritivo para a configuração, como "Totem sem Vitais".
     * @property {ProviderConfig} provider - Contém as configurações relacionadas ao provedor de dados ou de hardware.
     * @property {boolean} status - Indica se a configuração do centro de custo está ativa (true) ou inativa (false).
     */

    /**
     * @typedef {object} ProviderConfig
     * @property {MeasurementConfig} measurements - Agrupa as configurações de medição do provedor.
     */

    /**
     * Define os parâmetros para os diferentes tipos de medição ou fluxos.
     * @typedef {object} MeasurementConfig
     * @property {null|object} attendance - Configurações para o fluxo de atendimento. O valor `null` pode indicar que não há uma configuração específica.
     * @property {null|object} flow - Configurações para o fluxo geral do processo. O valor `null` pode indicar que não há uma configuração específica.
     */

    /** @type {CostCenterConfig} */
    GET_COST_CENTER_SETTINGS: (state) => ({ ...state.costCenterSettings }),
  },
  mutations: {
    POPULATE_COMPANY_FINANCERESUME: (state, payload) => {
      if (payload) {
        state.financeresume = payload;
      }
    },
    POPULATE_ONE: (state, payload) => {
      if (payload) {
        state.entity = payload;
      }
    },
    POPULATE_COST_CENTER_SETTINGS: (state, payload) => (state.costCenterSettings = payload),
  },
  namespaced: true,
  state: {
    entity: null,
    financeresume: null,
    costCenterSettings: null,
  },
  strict: true,
};

CommonState.registerModule('settings', module);
